<app-spinner [isLoading]="isUpdating$ | async" [isFixedPosition]="false">
  @if ({
    docuentTypeList: docuentTypeList$ | async,
    selectedFile: selectedFile$ | async,
    isFileUploading: isFileUploading$ | async,
    selectedFileText: selectedFileText$ | async,
    systemConfigs: systemConfigs$ | async,
    isFileSizeValid: isFileSizeValid$ | async,
    moderationLastChangeDate: moderationLastChangeDate$ | async
  }; as data) {
    <form [formGroup]="editForm" #ngForm="ngForm" class="document-upload">
      <h2 class="document-upload__title">{{ 'label.UploadDocuments' | translate }}</h2>

      <div class="fields">
        <div>
          <hrra-file-upload
            [label]="'label.AttachDocument' | translate"
            [fileName]="data.selectedFile?.filename != null ? data.selectedFileText : null"
            [uploading]="data.isFileUploading"
            [invalid]="data.isFileSizeValid === false || (data.selectedFile?.filename == null && ngForm.submitted)"
            (fileSelected)="onFileSelect($event, data.systemConfigs.jobseeker.jobseekerAttachmentMaxSize)">
          </hrra-file-upload>

          @if (data.selectedFile?.filename == null && ngForm.submitted) {
            <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
          }
          @if (data.isFileSizeValid === false) {
            <mat-error class="validation-message">{{ 'message.JobseekerFileSizeValidation' | translate }}</mat-error>
          }
        </div>

        <div>
          <label class="field-label" for="document-upload-type">{{ 'label.DocumentType' | translate }}</label>
          <hrra-floating-field>
            <p-select
              inputId="document-upload-type"
              formControlName="documentTypeId"
              [options]="data.docuentTypeList"
              optionLabel="name"
              optionValue="value"
              [class.has-error]="editForm.controls['documentTypeId'].hasError('required') && (editForm.controls['documentTypeId'].touched || ngForm.submitted)"
              appDialogPanel>
            </p-select>
          </hrra-floating-field>
          @if (editForm.controls['documentTypeId'].hasError('required') && (editForm.controls['documentTypeId'].touched || ngForm.submitted)) {
            <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
          }
        </div>

        <div>
          <label class="field-label" for="document-upload-comment">{{ 'label.Comment' | translate }}</label>
          <hrra-floating-field>
            <input pInputText id="document-upload-comment" type="text" formControlName="comment">
          </hrra-floating-field>
        </div>
      </div>

      <div class="actions">
        <button
          type="submit"
          class="actions__button actions__button--save"
          (click)="onSave(data.selectedFile, data.isFileSizeValid, data.moderationLastChangeDate)">
          {{ 'label.Save' | translate }}
        </button>
        <button type="button" class="actions__button actions__button--cancel" [mat-dialog-close]="true">{{ 'label.Cancel' | translate }}</button>
      </div>
    </form>
  }
</app-spinner>
